<template>
  <div class="tooltip-wrapper" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <transition name="fade">
      <div 
        v-if="show" 
        class="tooltip-box" 
        :class="position"
      >
        <div class="tooltip-content">
          {{ text }}
        </div>
        <div class="tooltip-arrow"></div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "Tooltip",
  props: {
    text: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: "top",
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value)
    },
    maxWidth: {
      type: String,
      default: "200px"
    },
    delay: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      show: false,
      timeout: null
    };
  },
  methods: {
    showTooltip() {
      this.timeout = setTimeout(() => {
        this.show = true;
      }, this.delay);
    },
    hideTooltip() {
      clearTimeout(this.timeout);
      this.show = false;
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  }
};
</script>

<style scoped>
.tooltip-wrapper {
  width: 100%;
  position: relative;
  display: inline-block;
}

.tooltip-box {
  position: absolute;
  background-color: #2d3748;
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.4;
  z-index: 1000;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 
              0 2px 4px -1px rgba(0, 0, 0, 0.06);
  width: max-content;
  max-width: 200px;
  word-break: break-word;
  white-space: normal;
  text-align: left;
}

.tooltip-content {
  position: relative;
  z-index: 2;
  width: 100%;
  box-sizing: border-box;
}

.tooltip-arrow {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #2d3748;
  transform: rotate(45deg);
  z-index: 1;
}

/* Position styles */
.tooltip-box.top {
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
}

.tooltip-box.top .tooltip-arrow {
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}

.tooltip-box.bottom {
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
}

.tooltip-box.bottom .tooltip-arrow {
  top: -4px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}

.tooltip-box.left {
  right: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
}

.tooltip-box.left .tooltip-arrow {
  right: -4px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}

.tooltip-box.right {
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
}

.tooltip-box.right .tooltip-arrow {
  left: -4px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}

/* Animation */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>